export class ScheduleEditUx
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    // From Api
    NumberOfStartTimes: number;
    ShowEditScheduleAdvancedSettings: boolean;
    ShowEnabled: boolean;
    ShowEnableProgramCheckbox: boolean;
    ShowExclusionDays: boolean;
    ShowGrowIn: boolean;
    ShowMonthlyAdjust: boolean;
    ShowMvPumpDelay: boolean;
    ShowMVPumpForStation: boolean;
    ShowMVPumpStatus: boolean;
    ShowRestrictionDays: boolean;
    ShowRestrictionTimes: boolean;
    ShowSensors: boolean;
    ShowWaterBudget: boolean;
    ShowWaterDaysExclusions: boolean;
    ShowWaterDaysRestrictions: boolean;
    ShowZoneCycleSoakTime: boolean;
    ShowZoneDelay: boolean;

}
